export default function TopThreatsByProcessDirective() {
  return {
    template: require('./top-threats-by-process.html'),
    scope: {
      assessmentId: '=',
      canEdit: '<',
      status: '@',
    },
    controller: 'TopThreatsByProcessController',
    controllerAs: 'topThreatsByProcessVM',
    bindToController: true,
    replace: true,
  };
}
